import * as types from '../actionTypes/annualReturnEmployee'

export function getEmployeesForAnnualReturn(annualReturnEmployees) {
  return{
      type: types.GET_EMPLOYEES_FOR_ANNUAL_RETURN,
      annualReturnEmployees
  }
}



// WEBPACK FOOTER //
// ./src/actions/annualReturnEmployee.js